import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b00cb5886e1000149dc2e2/anridesign/src/app/business-scope/page.tsx");
